module.exports = __webpack_public_path__ + "static/media/upload-icon.4b9f9166.svg";